import { Button, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";

import CustomModal from "./CustomModal";
import "./PrescriptionAnnouncementModal.css";

interface PrescriptionAnnouncementModalProps {
  open: boolean;
  onClose: () => void;
}

const PrescriptionAnnouncementModal = ({
  open,
  onClose,
}: PrescriptionAnnouncementModalProps) => {
  const navigate = useNavigate();

  const handleDiscover = () => {
    onClose();
    navigate("/aide-prescription");
  };

  return (
    <CustomModal open={open} onClose={onClose} size="medium">
      <div className="prescription-announcement-modal">
        <IconButton
          aria-label="Fermer"
          className="prescription-announcement-modal__close"
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>

        <div className="prescription-announcement-modal__content">
          <h2 className="prescription-announcement-modal__title">
            L'<b>outil d'aide à la prescription</b> est enfin disponible !
          </h2>

          <p className="prescription-announcement-modal__text">
            Trouvez en quelques clics le traitement antibiotique recommandé à la
            situation clinique.
          </p>

          <div className="prescription-announcement-modal__button-container">
            <Button
              variant="contained"
              color="primary"
              size="large"
              onClick={handleDiscover}
              className="prescription-announcement-modal__button"
            >
              Découvrir l'outil
            </Button>
          </div>
        </div>
      </div>
    </CustomModal>
  );
};

export default PrescriptionAnnouncementModal;
